/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Solution_Benefit_1Inputs */

const en_solution_benefit_1 = /** @type {(inputs: Solution_Benefit_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get the key points of a 1-hour YouTube video in minutes`)
};

const de_solution_benefit_1 = /** @type {(inputs: Solution_Benefit_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In wenigen Minuten das Wichtigste aus einstündigen YouTube-Videos verstehen`)
};

const zh_tw_solution_benefit_1 = /** @type {(inputs: Solution_Benefit_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`幾分鐘弄懂一小時的 YouTube 影片重點`)
};

const zh_cn_solution_benefit_1 = /** @type {(inputs: Solution_Benefit_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`几分钟弄懂一小时的 YouTube 视频重点`)
};

const es_solution_benefit_1 = /** @type {(inputs: Solution_Benefit_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entiende en minutos lo clave de un video de YouTube de una hora`)
};

const fr_solution_benefit_1 = /** @type {(inputs: Solution_Benefit_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprendre une vidéo YouTube d'une heure en quelques minutes`)
};

const it_solution_benefit_1 = /** @type {(inputs: Solution_Benefit_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capire un video YouTube di un'ora in pochi minuti`)
};

const pt_br_solution_benefit_1 = /** @type {(inputs: Solution_Benefit_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entenda em minutos o essencial de um vídeo de uma hora no YouTube`)
};

const ja_solution_benefit_1 = /** @type {(inputs: Solution_Benefit_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1時間の YouTube 動画も、数分でポイントがわかる`)
};

const ko_solution_benefit_1 = /** @type {(inputs: Solution_Benefit_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1시간짜리 YouTube 영상 핵심을 몇 분 만에 파악`)
};

const ru_solution_benefit_1 = /** @type {(inputs: Solution_Benefit_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разобраться в часовом YouTube-видео за пару минут`)
};

const th_solution_benefit_1 = /** @type {(inputs: Solution_Benefit_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าใจวิดีโอ YouTube ยาวชั่วโมงได้ในไม่กี่นาที`)
};

const tr_solution_benefit_1 = /** @type {(inputs: Solution_Benefit_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir saatlik YouTube videosunu birkaç dakikada özümse`)
};

const ar_solution_benefit_1 = /** @type {(inputs: Solution_Benefit_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افهم أهم نقاط فيديو YouTube طويل في دقائق بدلاً من ساعة`)
};

/**
* | output |
* | --- |
* | "Get the key points of a 1-hour YouTube video in minutes" |
*
* @param {Solution_Benefit_1Inputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const solution_benefit_1 = /** @type {((inputs?: Solution_Benefit_1Inputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Solution_Benefit_1Inputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_solution_benefit_1(inputs)
	if (locale === "de") return de_solution_benefit_1(inputs)
	if (locale === "zh_tw") return zh_tw_solution_benefit_1(inputs)
	if (locale === "zh_cn") return zh_cn_solution_benefit_1(inputs)
	if (locale === "es") return es_solution_benefit_1(inputs)
	if (locale === "fr") return fr_solution_benefit_1(inputs)
	if (locale === "it") return it_solution_benefit_1(inputs)
	if (locale === "pt_br") return pt_br_solution_benefit_1(inputs)
	if (locale === "ja") return ja_solution_benefit_1(inputs)
	if (locale === "ko") return ko_solution_benefit_1(inputs)
	if (locale === "ru") return ru_solution_benefit_1(inputs)
	if (locale === "th") return th_solution_benefit_1(inputs)
	if (locale === "tr") return tr_solution_benefit_1(inputs)
	return ar_solution_benefit_1(inputs)
});